import React, { FunctionComponent } from 'react';
import { Grid } from '@material-ui/core';
import SpecialtyEntity from '../../../../entities/Specialty.Entity';
import LanguageEntity from '../../../../entities/Language.Entity';
import SpecificBodyPartEntity from '../../../../entities/SpecificBodyPart.Entity';
import StateEntity from '../../../../entities/State.Entity';
import ReferralContactEntity from '../../../../entities/ReferralContact.Entity';
import ImeEntity from '../../../../entities/Ime.Entity';
import { ServicesEnum } from '../../../../support/enums/Services.Enum';
import { ImeReferralForm } from './ime-referral-form/ImeReferralForm.Component';
import { MedicalServiceReferralForm } from './ms-referral-form/MedicalServiceReferralForm.Component';
import InjuryTypeEntity from '../../../../entities/pt/InjuryType.Entity';
import BodySideEntity from '../../../../entities/BodySide.Entity';
import IMECoverLetterEntity from '../../../../entities/IMECoverLetter.Entity';
import MedicalServiceDataModel from '../../../../data-models/MedicalService.DataModel';
import ServiceTypeEntity from '../../../../entities/ServiceType.Entity';
import DiagnosticProcedureDetailDataModel from '../../../../data-models/DiagnosticProcedureDetail.DataModel';
import DiagnosticServiceDataModel from '../../../../data-models/DiagnosticService.DataModel';
import { DiagnosticServiceReferralForm } from './ms-referral-form/DiagnosticServiceReferralForm.Component';
import DiagnosisDataModel from '../../../../data-models/Diagnosis.DataModel';
import { UrReferralForm } from './ms-referral-form/UrReferralForm.Component';
import UtilizationReviewServiceDataModel from '../../../../data-models/UtilizationReviewService.DataModel';
import AppointmentTypeEntity from '../../../../entities/AppointmentType.Entity';
import DestinationEntity from '../../../../entities/Destination.Entity';
import InterpretationTypeEntity from '../../../../entities/InterpretationType.Entity';
import OriginationEntity from '../../../../entities/Origination.Entity';
import TransportationRequiredEntity from '../../../../entities/TransportationRequired.Entity';
import TransportationDataModel from '../../../../data-models/Transportation.DataModel';
import TranslationDataModel from '../../../../data-models/Translation.DataModel';
import { TtReferralForm } from './ms-referral-form/TtReferralForm.Component';
import { WheelchairOrStrecherDetailEntity } from '../../../../entities/WheelchairOrStrecherDetail.Entity';
import { DmeReferralForm } from './ms-referral-form/DmeReferralForm.Component';
import DmeServiceDataModel from '../../../../data-models/dme/DmeService.DataModel';
import ProductCategoryEntity from '../../../../entities/dme/ProductCategory.Entity';
import { TcmReferralForm } from './tcm-referral-form/TcmReferralForm.Component';
import TcmCoverLetterEntity from '../../../../entities/tcm/TcmCoverLetter.Entity';
import TcmMedicalInfoEntity from '../../../../entities/tcm/TcmMedicalInfo.Entity';
import TcmTreatingProviderEntity from '../../../../entities/tcm/TcmTreatingProvider.Entity';
import TcmOfficeVisitEntity from '../../../../entities/tcm/TcmOfficeVisit.Entity';
import TcmWorkStatusEntity from '../../../../entities/tcm/TcmWorkStatus.Entity';
import TcmTelephonicCaseManagementEntity from '../../../../entities/tcm/TcmTelephonicCaseManagement.Entity';
import SurveillanceServiceDataModel from '../../../../data-models/SurveillanceService.DataModel';
import { SiuSurveillanceReferralForm } from './siu-surveillance-referral-form/SiuSurveillanceReferralForm.Component';
import FacilityTypeEntity from '../../../../entities/FacilityType.Entity';
import { FcmReferralForm } from './fcm-referral-form/FcmReferralForm.Component';
import { RtwReferralForm } from './rtw-referral-form/RtwReferralForm.Component';
import ServiceTypeRequestFcmEntity from '../../../../entities/fcm/ServiceTypeRequestFcm.Entity';
import ServiceTypeRequestRtwEntity from '../../../../entities/rtw/ServiceTypeRequestRtw.Entity';

interface IReferralFormProps {
    //Required for IME
    referralId: number;
    specialties?: Array<SpecialtyEntity>;
    languages?: Array<LanguageEntity>;
    bodyParts?: Array<SpecificBodyPartEntity>;
    states?: Array<StateEntity>;
    ime?: ImeEntity;
    specificBodyParts?: Array<number>;
    handleImeEdit?: (edit: ImeEntity) => void;
    treatingPhysician?: ReferralContactEntity;
    handleTreatingPhysicianEdit?: any;
    getMedicalService?: any;
    optionalImePhysician?: ReferralContactEntity;
    handleOptionalImePhysicianEdit?: any;
    handleImeBodyPartsEdit?: any;
    serviceId?: number;
    //Required for PT
    medicalService: MedicalServiceDataModel;
    handleMedicalServiceEdit: any;
    injuryTypes: Array<InjuryTypeEntity>;
    bodySides: Array<BodySideEntity>;
    handleSetValidationFunction: (currentPageValidationFunction: () => boolean) => void;
    handleImeCoverLetterEdit: (edit: IMECoverLetterEntity) => void;
    coverLetterState: IMECoverLetterEntity;
    serviceTypes: Array<ServiceTypeEntity>;
    procedureDetails: Array<DiagnosticProcedureDetailDataModel>;
    handleSpecificBodyPart: (sbpId: number) => void;

    diagnosticService: DiagnosticServiceDataModel;
    handleDiagnosticServiceEdit: any;
    nextStep: boolean;
    searchDiagnosisByCodeDescription: (description: string) => void;
    diagnosisFindedArray: Array<DiagnosisDataModel>;
    getDxSpecificBodyParts: (serviceTypeId: number) => void;
    loadingDiagnosis: boolean;

    handleUtilizationReviewServiceEdit: any;
    utilizationReviewService: UtilizationReviewServiceDataModel;
    getDxProcedureDetailsByServiceTypeId: (serviceTypeId: number) => void;

    translationService: TranslationDataModel;
    transportationService: TransportationDataModel;
    interpretationTypes: Array<InterpretationTypeEntity>;
    appointmentTypes: Array<AppointmentTypeEntity>;
    transportationRequireds: Array<TransportationRequiredEntity>;
    originations: Array<OriginationEntity>;
    destinations: Array<DestinationEntity>;
    handleTransportationServiceEdit?: (edit: TransportationDataModel) => void;
    handleTranslationServiceEdit?: (edit: TranslationDataModel) => void;
    deleteServiceTypeRequestPtDetail: (procedureId: number) => void;
    handleClearInjuryTypes: () => void;
    wheelchairOrStrecherDetail: Array<WheelchairOrStrecherDetailEntity>;

    //DME
    dmeService: DmeServiceDataModel;
    handleDmeServiceEdit: (edit: DmeServiceDataModel) => void;
    productCategories: Array<ProductCategoryEntity>;
    
    handleSetIsValidImeFunction: (currentPageIsValidImeFunction: () => boolean, serviceTypeString: string) => void;
    handleSetIsValidPtFunction: (currentPageIsValidPtFunction: () => boolean, serviceTypeString: string) => void;
    handleSetIsValidDxFunction: (currentPageIsValidDxFunction: () => boolean, serviceTypeString: string) => void;
    handleSetIsValidDmeFunction: (currentPageIsValidDmeFunction: () => boolean, serviceTypeString: string) => void;
    handleSetIsValidUrFunction: (currentPageIsValidUrFunction: () => boolean, serviceTypeString: string) => void;
    handleSetIsValidTtFunction: (currentPageIsValidTtFunction: () => boolean, serviceTypeString: string) => void;
    handleSetIsValidRtwFunction: (currentPageIsValidRtwFunction: () => boolean, serviceTypeString: string) => void;
    
    openCloseStatus: Record<string, boolean>;
    handleOpenCloseStatus: (boxName: string, isOpened: boolean) => void;
    
    handleUpdateIme: (currentPageIsValidImeFunction: () => boolean) => void;
    handleUpdateTreatingPhysician: (currentPageIsValidTreatingPhysicianFunction: () => boolean) => void;
    handleUpdateOptionalImePhysician: (currentPageIsValidOptionalImePhysicianFunction: () => boolean) => void;
    handleUpdateImeCoverLetter: () => void;

    // TCM
    tcmTelephonicCaseManagement?: TcmTelephonicCaseManagementEntity;
    handleTcmTelephonicCaseManagementEdit?: (tcm: TcmTelephonicCaseManagementEntity) => void;
    
    tcmCoverLetter?: TcmCoverLetterEntity;
    handleTcmCoverLetterEdit?: (edit: TcmCoverLetterEntity) => void;
    
    tcmMedicalInfo?: TcmMedicalInfoEntity;
    handleTcmMedicalInfoEdit?: (edit: TcmMedicalInfoEntity) => void;
    
    tcmTreatingProvider?: TcmTreatingProviderEntity;
    handleTcmTreatingProviderEdit?: (provider: TcmTreatingProviderEntity) => void;
    
    tcmOfficeVisit?: TcmOfficeVisitEntity;
    handleTcmOfficeVisitEdit?: (visit: TcmOfficeVisitEntity) => void;
    
    tcmWorkStatus?: TcmWorkStatusEntity;
    handleTcmWorkStatusEdit?: (status: TcmWorkStatusEntity) => void;

    // SIU Surveillance (resubmit)
    siuServiceTypeIds?: number[];
    siuFacilityTypeCatalog?: Array<FacilityTypeEntity>;
    surveillanceService?: SurveillanceServiceDataModel | null;
    onSurveillanceServiceChange?: (next: SurveillanceServiceDataModel) => void;
    showSiuNumberOfDaysError?: boolean;
    showSiuOptionError?: boolean;
    showSiuCaseDetailsError?: boolean;

    // FCM (resubmit)
    fcmServiceTypeRequest?: ServiceTypeRequestFcmEntity | null;
    onFcmServiceTypeRequestChange?: (next: ServiceTypeRequestFcmEntity) => void;

    // RTW (resubmit)
    rtwServiceTypeRequest?: ServiceTypeRequestRtwEntity | null;
    onRtwServiceTypeRequestChange?: (next: ServiceTypeRequestRtwEntity) => void;
    showRtwValidationError?: boolean;
    showTtValidationError?: boolean;
    selectedTranslationServiceType?: ServiceTypeEntity;
    ttRushRequest: boolean;
    onTtRushRequestChange: (checked: boolean) => void;
}

export const ReferralForm: FunctionComponent<IReferralFormProps> = (props: IReferralFormProps) => {
    const getForm = () => {
        switch (props.serviceId) {
            case ServicesEnum.IME:
                return (
                    <ImeReferralForm
                        bodyParts={props.bodyParts}
                        ime={props.ime}
                        languages={props.languages}
                        specialties={props.specialties}
                        specificBodyParts={props.specificBodyParts}
                        states={props.states}
                        optionalImePhysician={props.optionalImePhysician}
                        treatingPhysician={props.treatingPhysician}
                        referralId={props.referralId}
                        handleImeBodyPartsEdit={props.handleImeBodyPartsEdit}
                        handleImeEdit={props.handleImeEdit}
                        handleOptionalImePhysicianEdit={props.handleOptionalImePhysicianEdit}
                        handleTreatingPhysicianEdit={props.handleTreatingPhysicianEdit}
                        coverLetterState={props.coverLetterState}
                        handleImeCoverLetterEdit={props.handleImeCoverLetterEdit}
                        handleSetValidationFunction={props.handleSetValidationFunction}
                        handleSetIsValidImeFunction={props.handleSetIsValidImeFunction}
                        
                        openCloseStatus={props.openCloseStatus}
                        handleOpenCloseStatus={props.handleOpenCloseStatus}
                        
                        handleUpdateIme={props.handleUpdateIme}
                        handleUpdateTreatingPhysician={props.handleUpdateTreatingPhysician}
                        handleUpdateOptionalImePhysician={props.handleUpdateOptionalImePhysician}
                        handleUpdateImeCoverLetter={props.handleUpdateImeCoverLetter}
                    />
                );
            case ServicesEnum.PT:
                return (
                    <MedicalServiceReferralForm
                        handleMedicalServiceEdit={props.handleMedicalServiceEdit}
                        referralId={props.referralId}
                        medicalService={props.medicalService}
                        specificBodyParts={props.bodyParts}
                        bodySides={props.bodySides}
                        injuryTypes={props.injuryTypes}
                        states={props.states}
                        handleSetValidationFunction={props.handleSetValidationFunction}
                        handleSetIsValidPtFunction={props.handleSetIsValidPtFunction}

                        openCloseStatus={props.openCloseStatus}
                        handleOpenCloseStatus={props.handleOpenCloseStatus}

                        serviceId={props.serviceId}
                        serviceTypes={props.serviceTypes}
                        getMedicalService={props.getMedicalService}
                        procedureDetails={props.procedureDetails}
                        diagnosticService={props.diagnosticService}
                        nextStep={props.nextStep}
                        handleDiagnosticServiceEdit={props.handleDiagnosticServiceEdit}
                        handleSpecificBodyPart={props.handleSpecificBodyPart}
                        languages={props.languages}
                        deleteServiceTypeRequestPtDetail={props.deleteServiceTypeRequestPtDetail}
                        handleClearInjuryTypes={props.handleClearInjuryTypes}
                    />
                );
            case ServicesEnum.Diagnostic:
                return (
                    <DiagnosticServiceReferralForm
                        handleMedicalServiceEdit={props.handleMedicalServiceEdit}
                        referralId={props.referralId}
                        medicalService={props.medicalService}
                        specificBodyParts={props.bodyParts}
                        bodySides={props.bodySides}
                        injuryTypes={props.injuryTypes}
                        states={props.states}
                        handleSetValidationFunction={props.handleSetValidationFunction}
                        handleSetIsValidDxFunction={props.handleSetIsValidDxFunction}
                        
                        openCloseStatus={props.openCloseStatus}
                        handleOpenCloseStatus={props.handleOpenCloseStatus}

                        serviceId={props.serviceId}
                        serviceTypes={props.serviceTypes}
                        getMedicalService={props.getMedicalService}
                        procedureDetails={props.procedureDetails}
                        diagnosticService={props.diagnosticService}
                        nextStep={props.nextStep}
                        handleDiagnosticServiceEdit={props.handleDiagnosticServiceEdit}
                        searchDiagnosisByCodeDescription={props.searchDiagnosisByCodeDescription}
                        diagnosisFindedArray={props.diagnosisFindedArray}
                        getDxSpecificBodyParts={props.getDxSpecificBodyParts}
                        getDxProcedureDetailsByServiceTypeId={props.getDxProcedureDetailsByServiceTypeId}
                        languages={props.languages}
                        loadingDiagnosis={props.loadingDiagnosis}
                    />
                );
            case ServicesEnum.UR:
                return (
                    <UrReferralForm
                        referralId={props.referralId}
                        specificBodyParts={props.bodyParts}
                        bodySides={props.bodySides}
                        injuryTypes={props.injuryTypes}
                        states={props.states}
                        handleSetValidationFunction={props.handleSetValidationFunction}
                        handleSetIsValidUrFunction={props.handleSetIsValidUrFunction}
                        
                        openCloseStatus={props.openCloseStatus}
                        handleOpenCloseStatus={props.handleOpenCloseStatus}

                        serviceId={props.serviceId}
                        serviceTypes={props.serviceTypes}
                        getMedicalService={props.getMedicalService}
                        utilizationReviewService={props.utilizationReviewService}
                        nextStep={props.nextStep}
                        handleUtilizationReviewServiceEdit={props.handleUtilizationReviewServiceEdit}
                        handleSpecificBodyPart={props.handleSpecificBodyPart}
                    />
                );
            case ServicesEnum.TT:
                return (
                    <TtReferralForm
                        referralId={props.referralId}
                        states={props.states}
                        handleSetValidationFunction={props.handleSetValidationFunction}
                        handleSetIsValidTtFunction={props.handleSetIsValidTtFunction}
                        
                        openCloseStatus={props.openCloseStatus}
                        handleOpenCloseStatus={props.handleOpenCloseStatus}

                        serviceId={props.serviceId}
                        serviceTypes={props.serviceTypes}
                        selectedTranslationServiceType={props.selectedTranslationServiceType}
                        nextStep={props.nextStep}
                        handleTranslationServiceEdit={props.handleTranslationServiceEdit}
                        translationService={props.translationService}
                        appointmentTypes={props.appointmentTypes}
                        interpretationTypes={props.interpretationTypes}
                        languages={props.languages}
                        handleTransportationServiceEdit={props.handleTransportationServiceEdit}
                        transportationService={props.transportationService}
                        transportationRequireds={props.transportationRequireds}
                        originations={props.originations}
                        destinations={props.destinations}
                        wheelchairOrStrecherDetail={props.wheelchairOrStrecherDetail}
                        showTtValidationError={props.showTtValidationError}
                        ttRushRequest={props.ttRushRequest}
                        onTtRushRequestChange={props.onTtRushRequestChange}
                        layoutVariant="wizard"
                    />
                );
            case ServicesEnum.DME:
                return (
                    <DmeReferralForm
                        referralId={props.referralId}
                        serviceTypes={props.serviceTypes}
                        handleSetValidationFunction={props.handleSetValidationFunction}
                        handleSetIsValidDmeFunction={props.handleSetIsValidDmeFunction}

                        openCloseStatus={props.openCloseStatus}
                        handleOpenCloseStatus={props.handleOpenCloseStatus}

                        dmeService={props.dmeService}
                        productCategories={props.productCategories}
                        handleDmeServiceEdit={props.handleDmeServiceEdit}
                        serviceId={props.serviceId}
                        states={props.states}
                    />
                );
            case ServicesEnum.TCM:
                return (
                    <TcmReferralForm
                        referralId={props.referralId}
                        states={props.states}
                        tcmTelephonicCaseManagement={props.tcmTelephonicCaseManagement}
                        handleTcmTelephonicCaseManagementEdit={props.handleTcmTelephonicCaseManagementEdit}
                        
                        coverLetterState={props.tcmCoverLetter}
                        handleTcmCoverLetterEdit={props.handleTcmCoverLetterEdit}
                        
                        tcmMedicalInfo={props.tcmMedicalInfo}
                        handleTcmMedicalInfoEdit={props.handleTcmMedicalInfoEdit}

                        tcmTreatingProvider={props.tcmTreatingProvider}
                        handleTcmTreatingProviderEdit={props.handleTcmTreatingProviderEdit}
                        
                        tcmOfficeVisit={props.tcmOfficeVisit}
                        handleTcmOfficeVisitEdit={props.handleTcmOfficeVisitEdit}
                        
                        tcmWorkStatus={props.tcmWorkStatus}
                        handleTcmWorkStatusEdit={props.handleTcmWorkStatusEdit}
                        
                        handleSetValidationFunction={props.handleSetValidationFunction}
                        openCloseStatus={props.openCloseStatus}
                        handleOpenCloseStatus={props.handleOpenCloseStatus}
                    />
                );
            case ServicesEnum.SIU:
                return (
                    <SiuSurveillanceReferralForm
                        referralId={props.referralId}
                        serviceTypeIds={props.siuServiceTypeIds ?? []}
                        facilityTypeCatalog={props.siuFacilityTypeCatalog ?? []}
                        surveillanceService={props.surveillanceService ?? null}
                        onSurveillanceChange={props.onSurveillanceServiceChange}
                        openCloseStatus={props.openCloseStatus}
                        handleOpenCloseStatus={props.handleOpenCloseStatus}
                        handleSetValidationFunction={props.handleSetValidationFunction}
                        showSiuNumberOfDaysError={props.showSiuNumberOfDaysError}
                        showSiuOptionError={props.showSiuOptionError}
                        showSiuCaseDetailsError={props.showSiuCaseDetailsError}
                    />
                );
            case ServicesEnum.FCM:
                return (
                    <FcmReferralForm
                        fcmServiceTypeRequest={props.fcmServiceTypeRequest ?? null}
                        onFcmServiceTypeRequestChange={props.onFcmServiceTypeRequestChange}
                        openCloseStatus={props.openCloseStatus}
                        handleOpenCloseStatus={props.handleOpenCloseStatus}
                    />
                );
            case ServicesEnum.RTW:
                return (
                    <RtwReferralForm
                        rtwServiceTypeRequest={props.rtwServiceTypeRequest ?? null}
                        onRtwServiceTypeRequestChange={props.onRtwServiceTypeRequestChange}
                        openCloseStatus={props.openCloseStatus}
                        handleOpenCloseStatus={props.handleOpenCloseStatus}
                        handleSetValidationFunction={props.handleSetValidationFunction}
                        handleSetIsValidRtwFunction={props.handleSetIsValidRtwFunction}
                        showRtwValidationError={props.showRtwValidationError}
                    />
                );
            default:
                return '';
        }
    };

    return (
        <Grid container spacing={3}>
            {getForm()}
        </Grid>
    );
};
